import '../sass/video.scss';

(() => {
    const $videoBlocks = document.querySelectorAll('.video');

    if (!$videoBlocks) return;

    $videoBlocks.forEach($videoBlock => {
        const $video = $videoBlock.querySelector('.video__player');

        let video = null;

        const initParallax = () => {
            if (!$videoBlock.classList.contains('video--has-parallax')) return;

            const movement = window.innerWidth / 10;
            
            let scrollFraction = (-1 * ($videoBlock.getBoundingClientRect().top - window.innerHeight)) / ($video.clientHeight + window.innerHeight);

            $video.style.transform = `translateY(${- movement +(movement * 2) * scrollFraction}px)`;
        };

        const initPlayer = () => {
            if (!$video) return;

            video = new Plyr($video, {
                controls: $video.classList.contains('video--has-controls') ? ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'airplay', 'fullscreen'] : null,
                clickToPlay: false,
            });
        };

        const autoplay = () => {
            if (video.playing && ($videoBlock.getBoundingClientRect().top + ($videoBlock.clientHeight / 2) >= window.innerHeight / 2 || !video)) return;
            
            video.play();

            video.on('playing', () => {
                window.removeEventListener('scroll', autoplay);
            });
        };

        window.addEventListener('scroll', initParallax);

        window.addEventListener('scroll', autoplay);

        window.addEventListener('resize', initParallax);

        initParallax();
        initPlayer();
        autoplay();
    });
})();
